import React, { useState } from "react";
import "./HTML_MAIN_CSS.css";

const HTML_Bootcamp = () => {
  const bootcampSections = [
    {
      title: "Introduction to HTML",
      topics: [
        {
          topic: "What is HTML?",
          content:
            "HTML (HyperText Markup Language) is the standard language for creating web pages. It defines the structure of a page using elements like headings, paragraphs, links, images, and lists.",
        },
        {
          topic: "HTML Versions & Evolution",
          content:
            "HTML evolved from basic HTML 2.0 to HTML 4.0 introducing semantic elements, and then to HTML5 which added multimedia support, APIs, and modern web capabilities.",
        },
        {
          topic: "Basic Structure of an HTML Document",
          content:
            "A standard HTML document includes <!DOCTYPE html>, <html>, <head>, and <body> elements. Example:\n\n<!DOCTYPE html>\n<html>\n  <head>\n    <title>Page Title</title>\n  </head>\n  <body>\n    <h1>Hello World!</h1>\n  </body>\n</html>",
        },
      ],
    },
    {
      title: "Text Formatting & Semantic Elements",
      topics: [
        {
          topic: "Text Formatting",
          content:
            "Use <b> for bold, <i> for italic, <u> for underline, <s> for strikethrough, <sup> and <sub> for superscript/subscript, and <mark> for highlighting text.",
        },
        {
          topic: "Semantic Elements",
          content:
            "Use <strong> for importance, <em> for emphasis, <abbr> for abbreviations, <time> for dates and times, and <small> for fine print.",
        },
        {
          topic: "Quotations & Citations",
          content:
            "Use <blockquote> for long quotes, <q> for inline quotes, and <cite> for references.",
        },
      ],
    },
    {
      title: "HTML Links & Images",
      topics: [
        {
          topic: "Links",
          content:
            "Create links using <a href='URL'>Link Text</a>. Use attributes like target='_blank', title, and rel='noopener noreferrer'.",
        },
        {
          topic: "Images",
          content:
            "Insert images using <img src='path' alt='description' width='' height=''>. Use <figure> and <figcaption> for captions.",
        },
        {
          topic: "Image Maps & Background Images",
          content:
            "Use <map> and <area> to create clickable regions on images. CSS can be used for background images with background-image property.",
        },
      ],
    },
    {
      title: "HTML Tables",
      topics: [
        {
          topic: "Creating Tables",
          content:
            "Use <table>, <tr>, <td>, <th> to define tables. Use colspan and rowspan to merge cells. Example:\n<table>\n  <tr><th>Header</th></tr>\n  <tr><td>Data</td></tr>\n</table>",
        },
        {
          topic: "Table Styling",
          content:
            "Use CSS to style tables: border, padding, spacing, text-align, background-color. Avoid using <table> for layout purposes.",
        },
      ],
    },
    {
      title: "HTML Forms",
      topics: [
        {
          topic: "Form Elements",
          content:
            "Forms are created using <form> with elements like <input>, <textarea>, <select>, <button>, <label>. Attributes like action and method define submission.",
        },
        {
          topic: "Input Types & Attributes",
          content:
            "Input types: text, password, email, number, date, file, checkbox, radio, submit, button. Attributes include placeholder, required, readonly, disabled, maxlength.",
        },
      ],
    },
    {
      title: "HTML Multimedia",
      topics: [
        {
          topic: "Audio & Video",
          content:
            "Use <audio> and <video> tags for embedding media. Attributes: controls, autoplay, loop, muted, poster.",
        },
        {
          topic: "HTML5 Canvas",
          content:
            "Use <canvas> to draw graphics using JavaScript. Example: <canvas id='myCanvas' width='200' height='100'></canvas>",
        },
      ],
    },
    {
      title: "Advanced HTML",
      topics: [
        {
          topic: "HTML APIs",
          content:
            "HTML5 provides APIs like Geolocation, Web Storage (localStorage & sessionStorage), Web Workers, Drag & Drop, SSE, and WebSockets for modern web apps.",
        },
        {
          topic: "HTML5 Semantic Layout",
          content:
            "Use <header>, <footer>, <main>, <article>, <section>, <aside>, <nav> to create structured, accessible web pages.",
        },
        {
          topic: "Responsive Design",
          content:
            "Use <meta name='viewport' content='width=device-width, initial-scale=1.0'>, CSS media queries, and flexible layouts to make pages responsive across devices.",
        },
      ],
    },
  ];

  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (index) => {
    setOpenSection(openSection === index ? null : index);
  };

  return (
    <div className="bootcamp-container">
      <h1>HTML Bootcamp: From Beginner to Advanced</h1>
      {bootcampSections.map((section, idx) => (
        <div key={idx} className="bootcamp-section">
          <h2
            className="section-title"
            onClick={() => toggleSection(idx)}
            style={{ cursor: "pointer" }}
          >
            {section.title}
          </h2>
          {openSection === idx && (
            <div className="section-topics">
              {section.topics.map((topic, tIdx) => (
                <div key={tIdx} className="topic-item">
                  <h3 className="topic-title">{topic.topic}</h3>
                  <p className="topic-content">{topic.content}</p>
                  <hr className="divider" />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default HTML_Bootcamp;
